var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedInImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#303c42",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "white",
    cx: 6,
    cy: 6,
    r: 1.5,
    "data-name": "<Path>"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M4.5 9.5h3v10h-3z",
    "data-name": "<Rectangle>"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M15.5 9.5a3.6 3.6 0 0 0-3 1.5V9.5h-3v10h3V14c0-1.66.89-2.5 2-2.5s2 .84 2 2.5v5.5h3V14c0-2.73-1.5-4.5-4-4.5Z",
    "data-name": "<Path>"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    x: 1.5,
    y: 1.5,
    "data-name": "<Rectangle>",
    rx: 1.5,
    ry: 1.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInImg);
export default __webpack_public_path__ + "static/media/linkedIn-img.b17ad4077819271647e663828234126d.svg";
export { ForwardRef as ReactComponent };